<template>
  <div class="laboratoryManagement">
    <header>
      <div class="title">管理痛点</div>
      <ManagementPainPoints :list="MANAGE_LIST"></ManagementPainPoints>
    </header>
    <main>
      <div class="title">方案亮点</div>
      <IconLights :list="LIGHTS"></IconLights>
    </main>
    <section class="wow animate__animated animate__fadeIn">
      <div class="title">方案优势</div>
      <Advantage :list="TECHNICAL_CAPACITY"></Advantage>
      <div class="title" style="margin-top: 56px">业务过程</div>
      <div class="lc-title">整合资源建平台，智能预约严管控，数据驱动优共享</div>
      <div class="lc">
        <div class="lc-left">
          <OssImg
            src="images/solution/resourceSharing/computer1.png"
            alt=""
          />
        </div>
        <div class="lc-right">
          <div class="lcList">
            <div class="lc-item maria" v-for="item in LC_LIST" :key="item.key">
              <div class="lc-img" :style="{ backgroundColor: item.color }">
                <OssImg :src="item.imgPath" />
              </div>
              <div style="flex: 1">
                <div class="lc-t">{{ item.text }}</div>
                <div class="lc-desc">{{ item.desc }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup>
import { ref,onMounted } from "vue";
import ManagementPainPoints from "./components/ManagementPainPoints.vue";
import IconLights from "./components/IconLights.vue";
import Advantage from "./components/Advantage.vue";
import { WOW } from 'wowjs'
onMounted(()=>{
  const wow = new WOW();
  wow.init();
})

const MANAGE_LIST = ref([
  {
    iconPath: "images/solution/safetyInspection/icon1.png",
    title: "巡检流程不规范",
    desc: "缺乏标准化巡检清单和操作指引，巡检内容、频次、路线随意，易遗漏关键风险点，导致隐患排查不全面",
    key: 0,
  },
  {
    iconPath: "images/solution/safetyInspection/icon2.png",
    title: "数据管理混乱",
    desc: "巡检数据多以纸质或分散电子表格存储，难以实现统一分析与整合，无法从海量数据中挖掘潜在风险趋势，难以为管理决策提供支撑",
    key: 1,
  },
  {
    iconPath: "images/solution/safetyInspection/icon3.png",
    title: "考核机制缺失",
    desc: "没有量化的巡检工作考核标准，难以评估巡检人员工作质量，无法形成有效激励和约束，降低巡检工作积极性和主动性",
    key: 2,
  },
  {
    iconPath: "images/solution/safetyInspection/icon4.png",
    title: "人员执行不到位",
    desc: "巡检人员专业能力参差不齐，责任心不足，存在敷衍了事、漏检错检现象，纸质记录易伪造、丢失，无法保证巡检真实性",
    key: 3,
  },
]);
const LIGHTS = ref([
  {
    desc: "通过 AI 算法结合实验室风险等级、设备使用频率等数据，自动生成动态巡检计划，灵活调整巡检频次与路线，确保高风险区域重点覆盖，低风险区域合理巡检，实现资源精准投放",
    imgPath: "images/solution/safetyInspection/light1.png",
    color: "#efeeff",
    key: 0,
  },
  {
    desc: "系统自动识别隐患类型并分级，秒级定位责任部门与人员，多渠道推送整改通知。通过倒计时预警、超期追责等机制，实时跟踪整改进度，整改完成后支持在线验收，形成隐患发现、处置、反馈的高效闭环",
    imgPath: "images/solution/safetyInspection/light2.png",
    color: "#fffaee",
    key: 1,
  },
  {
    desc: "度分析历史巡检数据、设备运行参数及行业事故案例，运用机器学习模型预测潜在安全风险，提前推送预防措施与维护建议，将安全管理从被动应对转为主动防控",
    imgPath: "images/solution/safetyInspection/light3.png",
    color: "#eef7ff",
    key: 2,
  },
]);

const TECHNICAL_CAPACITY = ref([
  {
    title: "全程数字化留痕",
    desc: "采用移动终端与物联网技术实现巡检全流程电子化，图文音视频多形式记录实时上传，数据不可篡改，彻底解决传统纸质记录易丢失、造假问题，责任追溯精准到个人",
    imgPath: "images/solution/safetyInspection/big_icon1.png",
    key: 0,
  },
  {
    title: "智能闭环管理",
    desc: "系统自动识别隐患并分级推送，倒计时预警与超期追责机制驱动整改，平均隐患处理周期缩短 50%，形成 “发现 - 处置 - 反馈” 高效闭环，降低安全事故发生概率",
    imgPath: "images/solution/safetyInspection/big_icon2.png",
    key: 1,
  },
  {
    title: "数据驱动预测",
    desc: "整合历史巡检、设备运行及行业案例数据，预测潜在风险，提前 3-5 天发出预警并提供预防方案，将被动应对转为主动防御，减少 80% 同类隐患复发",
    imgPath: "images/solution/safetyInspection/big_icon3.png",
    key: 2,
  },
  {
    title: "打破信息孤岛",
    desc: "打通多部门系统数据，支持跨部门联合巡检与在线会商，复杂安全问题解决效率提升 60%，消除部门间推诿扯皮现象",
    imgPath: "images/solution/safetyInspection/big_icon4.png",
    key: 3,
  },
  {
    title: "降低人力成本",
    desc: "自动化巡检计划生成与任务派发减少人工排程工作量，电子化数据处理降低纸质耗材与存档成本，同时避免因重复巡检造成的人力资源浪费",
    imgPath: "images/solution/safetyInspection/big_icon5.png",
    key: 4,
  },
  {
    title: "灵活扩展功能",
    desc: "模块化设计支持根据实验室规模、类型及管理需求灵活增减功能模块，如新增 专项巡检、定制化报表等，保障解决方案长期适配业务发展",
    imgPath: "images/solution/safetyInspection/big_icon6.png",
    key: 5,
  },
]);
const LC_LIST = ref([
  {
    imgPath: "images/solution/resourceSharing/control1.png",
    text: "使用前",
    desc: "系统依据实验室风险等级、设备类型和安全标准，自动生成个性化安全检查计划，明确检查项目、周期和责任人。检查人员通过移动终端接收任务，查阅检查清单与标准操作指南",
    color: "#efeeff",
    key: 0,
  },
  {
    imgPath: "images/solution/resourceSharing/control2.png",
    text: "使用中",
    desc: "检查人员抵达实验室后，扫码签到开启检查流程，对照电子检查清单逐项检查，利用移动终端拍照、录音、文字记录等方式采集现场数据，实时上传至系统",
    color: "#eef7ff",
    key: 1,
  },
  {
    imgPath: "images/solution/resourceSharing/control3.png",
    text: "使用后",
    desc: "自动汇总检查数据，生成可视化安全检查报告，展示隐患分布、整改进度等信息。通过大数据分析挖掘历史检查数据，预测潜在安全风险，生成风险预警与预防建议",
    color: "#fffaee",
    key: 2,
  },
]);
</script>

<style lang="scss" scoped>
.laboratoryManagement {
  $titleSize: 60px;

  font-family: "PingFang SC";
  .title {
    color: rgba(33, 33, 33, 1);
    font-weight: 500;
    font-size: $titleSize;
    text-align: center;
  }
  main {
    margin: 56px 0px;
  }
  section {
    margin-bottom: 56px;
    .lc-title {
      color: #424242;
      text-align: center;
      font-weight: 600;
      font-size: 32px;
      margin: 24px 0px 50px 0px;
    }
    .lc {
      display: flex;
      .lc-left {
      }
      .lc-right {
        margin-left: 32px;
        .lcList {
          display: flex;
          flex-direction: column;
          gap: 24px;
          .lc-item {
            box-sizing: border-box;
            padding: 16px;
            width: 100%;
            height: 150px;
            border-radius: 16px;
            background: #ffffff;
            display: flex;
            align-items: center;
            gap: 16px;
            .lc-img {
              width: 80px;
              border-radius: 80px;
              height: 80px;
              display: flex;
              justify-content: center;
              align-items: center;
            }
            .lc-t {
              color: #424242;
              font-weight: 500;
              font-size: 16px;
              margin-bottom: 10px;
            }
            .lc-desc {
              color: #888888;
              font-weight: 500;
              font-size: 14px;
            }
          }
        }
      }
    }
  }
}
</style>
